import React, { useEffect, useRef } from "react";

import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { clean } from "../util/dataUtil";
import "../styles/Dropdown.scss";

var footnotes = require("../data/footnotes.json");

type DropdownConfig = {
  name: string;
  data: string[];
  selectedOption: string;
  setOption(cat: string, value: string): void;
  isDisabled: boolean;
  info: boolean;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  })
);

const Dropdown: React.FC<DropdownConfig> = ({
  name,
  data,
  selectedOption,
  setOption,
  isDisabled,
  info,
}) => {
  const classes = useStyles();
  const options = Array.isArray(data) ? data : Object.keys(data);
  const footnotesContainer = useRef<HTMLDivElement | null>(null);

  const handleChange = (event: React.ChangeEvent<{ value: any }>) => {
    setOption(name, event.target.value);
  };

  useEffect(function () {
    if (info && footnotesContainer.current) {
      // position footnotexContainer below info icon
      var bbox = footnotesContainer.current.getBoundingClientRect();

      let footBox = Array.from(
        footnotesContainer.current.getElementsByClassName(
          "footnote-box"
        ) as HTMLCollectionOf<HTMLElement>
      )[0];
      footBox.style.left = bbox.left - 140 + "px";
      footBox.style.top = bbox.top + 40 + "px";
    }
  });
  return (
    <div className={"dropdown-container" + " " + clean(name) + "-dropdown"}>
      <FormControl className={classes.formControl} disabled={isDisabled}>
        <InputLabel id="demo-simple-select-label">{name}</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={selectedOption}
          onChange={handleChange}
          disableUnderline
        >
          {options.map((opt, i) => {
            return (
              <MenuItem key={i} value={opt}>
                {opt}
              </MenuItem>
            );
          })}
        </Select>
        {info && footnotes[selectedOption] ? (
          <div
            className="info"
            ref={(el) => (footnotesContainer.current = el)}
            onMouseOver={function (
              e: React.MouseEvent<HTMLDivElement, MouseEvent>
            ) {
              if (e.currentTarget.className.indexOf("show-box") === -1)
                e.currentTarget.className += " show-box";
            }}
            onMouseOut={function (
              e: React.MouseEvent<HTMLDivElement, MouseEvent>
            ) {
              if (e.currentTarget.className.indexOf("show-box") !== -1)
                e.currentTarget.className = e.currentTarget.className.replace(
                  /show-box/gi,
                  ""
                );
            }}
          >
            <div className="footnote-box">{footnotes[selectedOption]}</div>
          </div>
        ) : null}
      </FormControl>
    </div>
  );
};

export default Dropdown;
